import { Component } from '@angular/core';

@Component({
  selector: 'app-handover-initiate',
  templateUrl: './handover-initiate.component.html',
  styleUrls: ['./handover-initiate.component.scss'],
  standalone: false,
})
export class HandoverInitiateComponent {}
